(function () {
  'use strict';

  function initHero(root) {
    var track = root.querySelector('[data-wemai-hero-track]');
    if (!track) return;

    var realSlides = Array.from(track.querySelectorAll('[data-wemai-hero-slide]'));
    if (realSlides.length === 0) return;

    var prevBtn = root.querySelector('[data-wemai-hero-prev]');
    var nextBtn = root.querySelector('[data-wemai-hero-next]');
    var dots = root.querySelectorAll('[data-wemai-hero-dot]');
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-speed-ms'), 10) || 5000;
    var total = realSlides.length;
    var timer = null;

    if (total < 2) {
      // Single slide: just lay it out and stop
      realSlides.forEach(function (s) { s.style.minWidth = '100%'; s.style.maxWidth = '100%'; });
      return;
    }

    realSlides.forEach(function (s) { track.appendChild(s.cloneNode(true)); });
    realSlides.slice().reverse().forEach(function (s) { track.insertBefore(s.cloneNode(true), track.firstChild); });

    var allSlides = Array.from(track.children);
    var current = total;

    function getSlideWidthPx() {
      var vw = window.innerWidth;
      var pct = vw <= 749 ? 0.85 : 0.60;
      return Math.min(vw * pct, 800);
    }

    function normalizeCurrent() {
      if (current < total || current >= total * 2) {
        current = total + (((current - total) % total) + total) % total;
      }
    }

    function setPosition(animate) {
      var slideW = getSlideWidthPx();
      var containerW = window.innerWidth;
      var offset = (containerW - slideW) / 2;
      var pos = -(current * slideW) + offset;
      track.style.transition = animate ? 'transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'none';
      track.style.transform = 'translateX(' + pos + 'px)';
      allSlides.forEach(function (s) {
        s.style.minWidth = slideW + 'px';
        s.style.maxWidth = slideW + 'px';
      });
      allSlides.forEach(function (s, idx) {
        s.classList.toggle('is-active', idx === current);
      });
      var realIndex = ((current - total) % total + total) % total;
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === realIndex); });
    }

    function goTo(index) {
      current = index;
      setPosition(true);
    }

    track.addEventListener('transitionend', function () {
      if (current < total || current >= total * 2) {
        normalizeCurrent();
        setPosition(false);
      }
    });

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(function () { goTo(current + 1); }, speed);
    }
    function stopAutoplay() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { stopAutoplay(); goTo(current - 1); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stopAutoplay(); goTo(current + 1); startAutoplay(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stopAutoplay();
        var targetReal = parseInt(this.getAttribute('data-wemai-hero-dot'), 10);
        goTo(total + targetReal);
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        normalizeCurrent();
        setPosition(false);
        startAutoplay();
      }
    });

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        normalizeCurrent();
        setPosition(false);
        startAutoplay();
      }
    });

    var touchStartX = 0;
    var touchStartY = 0;
    var touchLastX = 0;
    var dragStartPos = 0;
    var isDragging = false;
    var lockedHorizontal = false;

    track.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchLastX = touchStartX;
      isDragging = true;
      lockedHorizontal = false;
      stopAutoplay();
      var slideW = getSlideWidthPx();
      dragStartPos = -(current * slideW) + (window.innerWidth - slideW) / 2;
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!isDragging || e.touches.length !== 1) return;
      var x = e.touches[0].clientX;
      var y = e.touches[0].clientY;
      var dx = x - touchStartX;
      var dy = y - touchStartY;
      if (!lockedHorizontal) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        if (Math.abs(dy) > Math.abs(dx)) {
          isDragging = false;
          setPosition(false);
          startAutoplay();
          return;
        }
        lockedHorizontal = true;
      }
      touchLastX = x;
      track.style.transition = 'none';
      track.style.transform = 'translateX(' + (dragStartPos + dx) + 'px)';
    }, { passive: true });

    function endTouch() {
      if (!isDragging) return;
      isDragging = false;
      if (!lockedHorizontal) {
        startAutoplay();
        return;
      }
      var dx = touchLastX - touchStartX;
      var slideW = getSlideWidthPx();
      var threshold = Math.min(slideW * 0.18, 60);
      if (dx <= -threshold) {
        goTo(current + 1);
      } else if (dx >= threshold) {
        goTo(current - 1);
      } else {
        setPosition(true);
      }
      startAutoplay();
    }

    track.addEventListener('touchend', endTouch);
    track.addEventListener('touchcancel', endTouch);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { setPosition(false); }, 80);
    });

    setPosition(false);
    startAutoplay();
  }

  function init() {
    document.querySelectorAll('[data-wemai-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
